import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

import { AuthenticationService } from '../_services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (this.isHeaderNeeded(request.url) && currentUser && currentUser.LoginSessionKey) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${currentUser.LoginSessionKey}`
                }
            });
        }


        return next.handle(request);
    }

    isHeaderNeeded(url: string) {

        // let excludeUrl = process.env.DOC_MANAGER_LAMBDA_PROD
        let excludeUrl = environment.DOC_MANAGER_LAMBDA_PROD;

        // let repoExludeUrl = process.env.REPO_SYNDIFI_PROD
        let repoExludeUrl = environment.REPO_SYNDIFI_PROD;

        if (url.indexOf(repoExludeUrl) > -1 || url.indexOf(excludeUrl) > -1 || url.indexOf("https://files-repo-prod.s3") > -1) {
            return false;
        } else {
            return true;
        }
    }
}